import { useState, useEffect, useMemo } from "react";

import Button from "components/Button/Button";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { List, ListItem, Stack, Text, HStack } from "@chakra-ui/layout";
// import { Image } from "@chakra-ui/image";

// import capitalize from "lodash/capitalize";
// import toUpper from "lodash/toUpper";

// import toPrecision from "util/toPrecision";
// import currencyFormatter from "util/formatter";
// import toCoinLocale from "util/toCoinLocale";

const ForStep1 = ({ data }) => {
  const keys = useMemo(() => Object.keys(data ?? {}), [data]);

  return (
    <Stack>
      <List>
        {keys?.map((key) => (
          <ListItem borderBottom="1px solid #4E4B661f" py="14px">
            <HStack justifyContent="space-between">
              <Text color="#4E4B66" fontSize="sm">
                {key}:
              </Text>
              <Text color="#14142B" fontSize="sm">
                {data[key]}
              </Text>
            </HStack>
          </ListItem>
        ))}
        {/* <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Mobile Operator:
            </Text>
            <HStack>
              <Image
                boxSize="28px"
                objectFit="contain"
                src={state?.operatorInfo?.logo}
                alt=""
              />

              <Text color="#14142B" fontSize="sm">
                {state?.operatorInfo?.name}
              </Text>
            </HStack>
          </HStack>
        </ListItem> */}
        {/* {plan && (
          <ListItem mt="20px">
            <HStack alignItems="flex-start">
              <Text color="#4E4B66" fontSize="sm">
                Plan:
              </Text>

              <Text color="#14142B" fontSize="sm">
                {plan}
              </Text>
            </HStack>
          </ListItem>
        )} */}
        {/* {state?.amount && (
          <ListItem mt="20px">
            <HStack alignItems="flex-start">
              <Text color="#4E4B66" fontSize="sm">
                Amount:
              </Text>

              <Text color="#14142B" fontSize="sm">
                {Number(state?.amount).toLocaleString()}{" "}
                {toUpper(state?.operatorInfo?.currency)}
              </Text>
            </HStack>
          </ListItem>
        )} */}
        {/* <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Wallet:
            </Text>

            <Text color="#14142B" fontSize="sm">
              {toCoinLocale(state?.coin)}
            </Text>
          </HStack>
        </ListItem> */}
        {/* <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Phone Number:
            </Text>

            <Text color="#14142B" fontSize="sm">
              {state?.phone}
            </Text>
          </HStack>
        </ListItem> */}
        {/* <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Fiat Price:
            </Text>

            <Badge fontSize="sm" colorScheme="green">
              {state?.operatorInfo?.currency && state?.prices
                ? currencyFormatter(state?.operatorInfo?.currency).format(
                    +state.prices.fiat ?? 0
                  )
                : "0"}
            </Badge>
          </HStack>
        </ListItem> */}
        {/* <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Crypto Price:
            </Text>

            <Badge fontSize="sm" colorScheme="green">
              {toPrecision(state?.prices?.crypto, state?.coin, true)}
            </Badge>
          </HStack>
        </ListItem> */}
      </List>
    </Stack>
  );
};

export default function SwapPreview(props) {
  const {
    isOpen,
    onClose,
    data,
    onConfirm,
    isLoading,
    title,
    forUpdate,
    buttonText,
  } = props;

  const [currentStep, setCurrentStep] = useState(0);
  const maxStep = 1;

  const previewMap = (step) => {
    const map = {
      0: <ForStep1 data={data} />,
    };

    return map[step];
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    } else {
      onClose();
    }
  };

  const handleNext = () => {
    if (currentStep < maxStep - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onConfirm && onConfirm();
    }
  };

  useEffect(() => setCurrentStep(0), [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          {title}
        </ModalHeader>
        <ModalCloseButton
          top="23px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="24px 48px">{previewMap(currentStep)}</ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            minW="120px"
            disabled={isLoading}
            onClick={handlePrev}
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            {currentStep <= 0
              ? buttonText && buttonText[0]
                ? buttonText[0]
                : "Close"
              : "Back"}
          </Button>
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            minW="120px"
            onClick={handleNext}
          >
            {currentStep === maxStep - 1
              ? forUpdate
                ? "Update"
                : buttonText && buttonText[1]
                ? buttonText[1]
                : "Swap"
              : "Next"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
